/** Reusable colored status badge for tables across admin pages */
interface StatusBadgeProps {
  label: string;
  color: string;
  bg: string;
  icon?: string;
}

export function StatusBadge({ label, color, bg, icon }: StatusBadgeProps) {
  return (
    <span style={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: '0.25rem',
      fontSize: '11px',
      padding: '2px 8px',
      borderRadius: '999px',
      backgroundColor: bg,
      color,
      whiteSpace: 'nowrap',
    }}>
      {icon && <span>{icon}</span>}
      {label}
    </span>
  );
}

export const STATUS_PAYMENT: Record<string, StatusBadgeProps> = {
  succeeded: { label: 'Pago',         color: '#4ade80', bg: 'rgba(74,222,128,0.12)',  icon: '✓' },
  failed:    { label: 'Falhou',        color: '#fca5a5', bg: 'rgba(239,68,68,0.1)',   icon: '✕' },
  refunded:  { label: 'Reembolsado',   color: '#fbbf24', bg: 'rgba(251,191,36,0.1)',  icon: '↩' },
  pending:   { label: 'Pendente',      color: '#94a3b8', bg: 'rgba(255,255,255,0.06)', icon: '⏳' },
};

export const STATUS_CHARGEBACK: Record<string, StatusBadgeProps> = {
  needs_response:  { label: 'Requer resposta', color: '#f87171', bg: 'rgba(239,68,68,0.15)', icon: '⚠️' },
  under_review:    { label: 'Em análise',      color: '#fbbf24', bg: 'rgba(251,191,36,0.1)',  icon: '🔍' },
  won:             { label: 'Ganho',           color: '#4ade80', bg: 'rgba(74,222,128,0.12)', icon: '✓' },
  lost:            { label: 'Perdido',         color: '#fca5a5', bg: 'rgba(239,68,68,0.1)',   icon: '✕' },
  closed:          { label: 'Encerrado',       color: '#94a3b8', bg: 'rgba(255,255,255,0.06)', icon: '-' },
};

export const STATUS_COUPON: Record<string, StatusBadgeProps> = {
  active:  { label: 'Ativo',   color: '#4ade80', bg: 'rgba(74,222,128,0.12)' },
  paused:  { label: 'Pausado', color: '#f87171', bg: 'rgba(239,68,68,0.1)' },
  expired: { label: 'Expirado',color: '#94a3b8', bg: 'rgba(255,255,255,0.06)' },
};
